
import { defineComponent } from 'vue';
import { getAllStats } from '../api/api'
import { UseRequest } from '../utils/useRequest'
import { team } from '@/types/team'
import { getAllStatsParamType } from '@/types/api'

import ProgressBar from "@/components/ProgressBar.vue";
import Error from "@/components/Error.vue";

export default defineComponent({
  components: {
    ProgressBar,
    Error
  },
  props: {
    playerId: String,
    season: Number
  },
  setup(props) {

    const stats = new UseRequest(getAllStats)
    // annotation is not work !! you have to check annotaion work when object passed as args
    stats.createRequest<getAllStatsParamType>({
      'player_ids[]': props.playerId,
      'seasons[]': props.season,
      'per_page': 100,
      'postseason': false
    }).then(() => {
      stats.result.value.data.sort((e1: any, e2: any) => {
        return e1.game.date < e2.game.date ? 1 : -1
      })
    }).then(() => {
      stats.result.value.data = stats.result.value.data.filter((v: any, index: number) => {
        return index < 10
      })
    })

    // args is annoted as string type but args will passed as number type. annotetion is not valid
    // maybe i have to annote the request response.
    const getTeamName = (teamId: number, homeTeamId: number, visitorTeamId: number): string => {
      return teamId === homeTeamId ? team[visitorTeamId] : team[homeTeamId]
    }

    const getDate = (date: string) => {
      return new Date(date).toLocaleDateString("en")
    }

    return {
      stats,
      getTeamName,
      getDate
    }
  },
});
